import { Spinner } from '@datacloud-incubation/frontend-common-library';
import classNames from 'classnames';
import { useEffect } from 'react';
import { animationService } from '@core/services/Animation.service';
import styles from '../WrapperAbcloudzFlowChat.module.css';

const Loading = () => {
  useEffect(() => {
    animationService.subscribe();
    return () => {
      animationService.unsubscribe();
    };
  }, []);

  return (
    <div className={classNames(styles.flowPage, styles.loading)}>
      <div className={styles.syncSpinner}>
        <Spinner />
      </div>
    </div>
  );
};

export default Loading;
